import React from 'react';

interface SelectButtonProps {
  children: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  width?: string;
  height?: string;
  size?: 'small' | 'medium' | 'large';
}

const SelectButton: React.FC<SelectButtonProps> = ({
  children,
  selected = false,
  onClick,
  disabled = false,
  width,
  height,
  size = 'small'
}) => {
  const sizeConfig = {
    small: { 
      height: '25px', 
      fontSize: '11px', 
      padding: '4px 8px',
      lineHeight: '16.50px'
    },
    medium: { 
      height: '32px', 
      fontSize: '13px', 
      padding: '6px 12px',
      lineHeight: '19.50px'
    },
    large: { 
      height: '40px', 
      fontSize: '14px', 
      padding: '8px 16px',
      lineHeight: '21px'
    }
  };

  const config = sizeConfig[size];
  const finalWidth = width || 'auto';
  const finalHeight = height || config.height;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        width: finalWidth,
        height: finalHeight,
        padding: config.padding,
        borderRadius: '4px',
        border: selected ? 'none' : '1px solid var(--Color-line-normal, #F0F0F0)',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'inline-flex',
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: disabled 
          ? '#F5F5F5' 
          : (selected ? 'var(--Color-fill-brand-color, #FF6F0F)' : 'white'),
        color: disabled 
          ? '#989898' 
          : (selected ? 'white' : '#161616'),
        fontSize: config.fontSize,
        fontWeight: '400',
        lineHeight: config.lineHeight,
        fontFamily: 'Pretendard',
        whiteSpace: 'nowrap',
        opacity: disabled ? 0.6 : 1,
        transition: 'all 0.2s ease',
        outline: 'none'
      }}
      onMouseEnter={(e) => {
        if (!disabled && !selected) {
          e.currentTarget.style.backgroundColor = '#F8F8F8';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled && !selected) {
          e.currentTarget.style.backgroundColor = 'white';
        }
      }}
    >
      {children}
    </button>
  );
};

export default SelectButton;
